<template>
    <kt-panel v-if="!activeGateways().has_gateway">
        <kt-panel-body>
            <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                {{ $t('message.no_gateway') }}
                <router-link
                        class="btn btn-brand d-block w-25 text-center align-content-center mx-auto mt-3"
                        to="/gateways"> {{ $t('btn.create_gateway') }}</router-link>
            </p>
        </kt-panel-body>
    </kt-panel>
    <kt-panel v-else-if="!activeGateways().has_active_gateway">
        <kt-panel-body>
            <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                {{ $t('message.no_active_gateway') }}
            </p>
        </kt-panel-body>
    </kt-panel>
    <form v-else @submit.prevent="submit" id="ps_form">
        <kt-form-section>
            <kt-col xs="12" class="mb-5" v-if="form_data.profile_image_link">
                <img :src="form_data.profile_image_link" width="100" height="100" style="max-width:150px; max-height:150px" class="d-block m-auto">
            </kt-col>
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="user_name">
                            {{ $t('label.user_name') }}
                        </kt-form-label>
                        <kt-form-control
                            disabled
                            id="user_name"
                            name="user_name"
                            v-model="form_data.user_name"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="pay_link_title">
                            {{ $t('label.pay_link_title') }}
                        </kt-form-label>
                        <select
                            id="pay_link_title"
                            name="pay_link_title"
                            v-model="form_data.pay_link_title"
                            class="form-control kt-selectpicker"
                        >
                            <option :value="form_data.full_name">{{ form_data.full_name }}</option>
                            <option
                                v-bind:key="gateway.id"
                                v-for="gateway in active_gateways"
                                :value="gateway.title"
                            >
                                {{ gateway.title }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>
        <kt-form-section>
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <kt-row>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group>
                                <kt-form-label for="shop_id">
                                    {{ $t('label.choose_gateway') }}
                                </kt-form-label>
                                <select
                                    id="shop_id"
                                    name="shop_id"
                                    v-model="form_data.shop_id"
                                    class="form-control kt-selectpicker"
                                >
                                    <option
                                        v-bind:key="gateway.id"
                                        v-for="gateway in activeGateways().gates"

                                        :value="gateway.id"
                                    >
                                        {{ gateway.title }}
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group>
                                <kt-form-label for="ivr_shop_id">
                                    {{ $t('label.vip_gateway') }}
                                </kt-form-label>
                                <select
                                    id="ivr_shop_id"
                                    name="ivr_shop_id"
                                    v-model="form_data.ivr_shop_id"
                                    class="form-control kt-selectpicker"
                                >
                                    <option
                                        v-bind:key="ivr.id"
                                        v-for="ivr in ivrs"
                                        :value="ivr.id"
                                    >
                                        {{ ivr.title }}
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                    <kt-row>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group>
                                <kt-form-label v-if="form_data.wage_plan === wageType.PERCENT" for="user_name">
                                    {{ $t('label.wage_percent') }}
                                </kt-form-label>

                                <kt-form-label v-else for="user_name">
                                    {{ $t('label.wage_amount') + ' (' + $t('label.rial') + ')' }}
                                </kt-form-label>
                                <kt-form-control
                                    disabled
                                    id="wage_amount"
                                    name="wage_amount"
                                    v-model="form_data.wage_amount"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                    <kt-row>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group>
                                <kt-form-label for="wage_type">
                                    {{ $t('label.wage_settings') }}
                                </kt-form-label>
                                <select
                                    id="wage_type"
                                    name="wage_type"
                                    v-model="form_data.wage_type"
                                    class="form-control kt-selectpicker"
                                >
                                    <option
                                        v-bind:key="wage.id"
                                        v-for="wage in wages"

                                        :value="wage.id"
                                    >
                                        {{ wage.value }}
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                    <kt-row>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group>
                                <kt-form-label for="show_phone_number-div">
                                    {{ $t('label.phone_number') }}
                                </kt-form-label>
                                <div class="custom-control custom-checkbox" id="show_phone_number-div">
                                    <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="show_phone_number"
                                            name="show_phone_number"
                                            v-model="form_data.show_phone_number"
                                    >
                                    <label class="custom-control-label" for="show_phone_number">
                                        {{ $t('label.show_phone_number') }}
                                    </label>
                                </div>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="description">
                            {{ $t('label.description') }}
                        </kt-form-label>
                        <Textarea
                                class="form-control no-resize"
                                rows="9"
                                id="description"
                                name="description"
                                v-model="form_data.description"
                        >
                        </Textarea>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <form>
                        <div class="input-group mb-4 mt-4 ">
                            <label class="input-group">
                                {{ $t('label.pardakhtShakhsiLink') }}
                            </label>
                            <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fa fa-copy" style="font-size:24px; cursor:pointer" title="copy" @click="copy"></i>
                            </span>
                            </div>
                            <input class="form-control" type="text" dir="ltr"  name="register_link" id="register_link"
                                   :value="form_data.pay_link" disabled
                            >
                        </div>
                    </form>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <div class="w-100 text-center"
                         id="qr"
                         data-toggle="modal"
                         data-target="#qr_modal"
                         @click="magnifyQR"
                    >
                    </div>
                </kt-col>
            </kt-row>
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <kt-col lg="6" md="6" xs="12" style="display: flex; float: right">
                        <kt-form-group>
                            <kt-form-label>
                                {{ $t('label.profile_image') }}
                            </kt-form-label>
                            <kt-form-label for="logo_file" class="d-block btn btn-secondary btn-wide label-file">
                                <kt-icon type="fa" name="paperclip"></kt-icon>
                                {{ $t('gateway.btn.click_me') }}
                            </kt-form-label>
                            <input
                                @change="processLogoFile"
                                type="file"
                                class="custom-file-upload"
                                name="profile_image"
                                id="logo_file"
                                accept=".jpg,.jpeg,image/png"
                            />
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12" style="display: flex;">
                        <img src="" id="preview" width="100" height="100" class="d-none m-auto">
                    </kt-col>

                </kt-col>
            </kt-row>
        </kt-form-section>
        <kt-form-action class="mt-4">
            <kt-button
                class="m-2"
                size="md"
                variant="success"
                type="submit"
                v-bind:wide="true"
                id="submit_btn"
            >
                {{ $t('panel.profile.update.wizard.form.btn.submit') }}
            </kt-button>
        </kt-form-action>

        <div id="qr_modal" class="modal fade rtl" role="dialog">
            <div class="modal-dialog modal-width">

                <!-- Modal content-->
                <div class="modal-content">
                    <div id="data_sheet" class="modal-body mb-4">
                        <div class="text-center" id="big_qr"></div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>

import $ from "jquery";
import { i18n } from '@/plugins/i18n'
import {mapGetters} from "vuex";
import Textarea from "../../../components/elements/form/textarea";
import {gatewayTypes} from "@/constants/gatewayTypes"
import QrCodeWithLogo from "qr-code-with-logo";
import {wageType} from "@/constants/WageTypes";

export default {
    components: {Textarea},
    props: {
        submit: {
            default: () => {},
            type: Function
        },
        form_data: {
            default() {
                return {}
            },
            type: Object
        }
    },
    data() {
        return {
            wage_types: [
                {
                    name: this.$t('gateway.wage_types.percent'),
                    value: 'PERCENT'
                },
                {
                    name: this.$t('gateway.wage_types.fixed'),
                    value: 'FIXED'
                },
                {
                    name: this.$t('gateway.wage_types.periodic'),
                    value: 'PERIODIC',
                }
            ],
            wage_periodic_types: [
                {
                    name: this.$t('gateway.wage_periodic_types.1'),
                    value: 1
                },
                {
                    name: this.$t('gateway.wage_periodic_types.3'),
                    value: 3
                },
                {
                    name: this.$t('gateway.wage_periodic_types.6'),
                    value: 6,
                },
                {
                    name: this.$t('gateway.wage_periodic_types.12'),
                    value: 12,
                }
            ],

            wages: [
                {
                    id: 0,
                    value: this.$t('gateway.wages.from_me')
                },
                {
                    id: 1,
                    value: this.$t('gateway.wages.from_payer')
                },
                {
                    id: 2,
                    value: this.$t('gateway.wages.half')
                }
            ],
            pardakhtShakhsiLink: window.location.origin + '/@' + this.form_data.user_name,
        }
    },
    mounted() {
        this.$store.dispatch('gateway/fetch').finally(() => {
            this.afterDispatch()
            this.createQrCode()
        })

    },
    methods: {
        processLogoFile(e) {
            this.form_data.profile_image = event.target.files[0]

            if (this.form_data.profile_image === undefined)
                $('#preview').attr('src',"")
            else {
                let size_validation = this.validateSize(event.target)
                if (size_validation != false) {
                    let format_validation = this.validateFormat(event.target)

                    if (format_validation)
                        this.previewImage(this.form_data.profile_image)
                }
            }
        },
        validateSize(file) {
            var FileSize = file.files[0].size / 1024 / 1024; // in MB
            if (FileSize > 1) {
                alert(i18n.t('authenticate.hint.fourth'));
                $(file).val('');
                return false
            } else {
                return true
            }
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, '');
            if (extension === file_name) {
                extension = '';
            } else {
                extension = extension.toLowerCase();
            }
            let result = true

            switch (extension) {
                case 'jpg':
                case 'jpeg':
                case 'png':
                    break;
                default:
                    alert(i18n.t('authenticate.input_format_err'));
                    $(file).val('');
                    result = false
            }
            return result
        },
        previewImage(logo_file) {
            $('#preview').attr('src',URL.createObjectURL(logo_file)).removeClass('d-none');
        },
        afterDispatch() {
            this.runSelectPicker()
            this.activeGateways()
        },
        copy() {
            let copiedLink = $('#register_link')
            copiedLink.removeAttr('disabled');
            copiedLink.select()
            document.execCommand("copy")
            copiedLink.attr('disabled','disabled');
        },
        activeGateways() {
            var active_gateways = []

            if (this.gateways.length < 1) {
                active_gateways.has_gateway = false
                return active_gateways
            }

            active_gateways.has_gateway = true

            active_gateways.gates = []
            active_gateways.has_active_gateway = false
            var gateway
            for (gateway of this.gateways) {
                if ((gateway.status === 1 || gateway.status === '1') && gateway.gateway_type === gatewayTypes.PARDAKHTYARI) {
                    active_gateways.gates.push(gateway)
                    active_gateways.has_active_gateway = true
                }

            }

            return active_gateways
        },
        createQrCode() {
            setTimeout(() => {
                let qr_canvas = document.createElement('canvas');
                qr_canvas.style.cursor = 'pointer';
                document.getElementById('qr').appendChild(qr_canvas);
                QrCodeWithLogo.toCanvas({
                    canvas: qr_canvas,
                    content: this.form_data.pay_link,
                    width: 200,
                    height: 200,
                    logo: {
                        // src: LocalImage,
                        src: this.form_data.QR_logo,
                        borderRadius: '20',
                        bgColor: '#fff',
                        logoSize: 0.25,
                        borderSize: 0
                    }
                })
            }, 5)
        },
        createBigQR() {
            $('#big_qr').empty()
            let qr_size = (window.innerWidth) * 0.7
            if (qr_size > 700)
                qr_size = 700
            const qr_canvas = document.createElement('canvas')
            document.getElementById('big_qr').appendChild(qr_canvas)
            QrCodeWithLogo.toCanvas({
                canvas: qr_canvas,
                content: this.pardakhtShakhsiLink,
                width: qr_size,
                height: qr_size,
                logo: {
                    // src: LocalImage,
                    src: this.form_data.QR_logo,
                    borderRadius: '50',
                    bgColor: '#fff',
                    logoSize: 0.25,
                    borderSize: 0
                }
            })
        },
        magnifyQR() {
            this.createBigQR()
        },
        runSelectPicker() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        }
    },
    computed: {
        wageType() {
            return wageType
        },
        ...mapGetters('gateway', [
            'gateways','active_gateways', 'ivrs'
        ]),
    }
}
</script>

<style scoped>
.no-resize {
    resize: none;
}
.modal-width{
     max-width: 700px
}
</style>
